import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: false
}

const chatBotEventsSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        startChat: (state) => {
            state.value = true;
        },
        resetChat: (state, action) => {
            state.value = action.payload
        },
        setText: (state, action) =>{
            state.value = action.payload
        }
    }
})

export const { startChat, resetChat, setText } = chatBotEventsSlice.actions;
export default chatBotEventsSlice.reducer